import { SUPPORTED_CHAIN_IDS } from '@ui/constants/chain';
import { useDataChainId } from '@ui/hooks/datachain';
import { ChainId } from '@ui/types/chain';
import { create } from 'zustand';

type ClosingOrdersState = {
  closingOrdersMap: Record<ChainId, string[]>;
  useClosingOrders: () => string[];
  addClosingOrder: (orderId: string, chainId: ChainId) => void;
  removeClosingOrder: (orderId: string, chainId: ChainId) => void;
  resetClosingOrders: () => void;
};

const defaultMap = Object.fromEntries(
  SUPPORTED_CHAIN_IDS.map((id) => [id, [] as string[]]),
) as Record<ChainId, string[]>;

export const useClosingOrdersStore = create<ClosingOrdersState>((set, get) => ({
  closingOrdersMap: defaultMap,
  useClosingOrders: () => {
    const chainId = useDataChainId();

    return get().closingOrdersMap[chainId];
  },
  addClosingOrder: (orderId, chainId) =>
    set((state) => {
      const list = state.closingOrdersMap[chainId] ?? [];
      if (list.includes(orderId)) return state;

      return {
        closingOrdersMap: {
          ...state.closingOrdersMap,
          [chainId]: [...list, orderId],
        },
      };
    }),
  removeClosingOrder: (orderId, chainId) =>
    set((state) => {
      const list = state.closingOrdersMap[chainId] ?? [];

      return {
        closingOrdersMap: {
          ...state.closingOrdersMap,
          [chainId]: list.filter((id) => id !== orderId),
        },
      };
    }),
  resetClosingOrders: () =>
    set({
      closingOrdersMap: defaultMap,
    }),
}));
